import { Component, Vue, Inject } from 'vue-property-decorator';
import AbpBase from '../../../lib/abpbase';
import _ from 'lodash';

@Component
export default class RoleTreeMixin extends AbpBase {
    get rolePermissions() {
        return []
    }

    selectedNodes = [];

    renderContent(h, { root, node, data }) {
        return h(
            "span",
            {
                style: {
                    display: "inline-block",
                    width: "100%"
                }
            },
            [
                h("span", [
                    h("span", data.title)
                ])
            ]
        );
    }

    initTreeChildren(parent, permission) {
        if (_.includes(permission, ".")) {
            const [first, ...others] = permission.split(".");
            let item = _.find(parent.children, t => t.name == first);
            if (item) {
                this.initTreeChildren(item, _.join(others, "."));
            } else {
                item = {
                    name: first,
                    key: parent.key + '.' + first,
                    expand: false,
                    children: []
                };
                item.title = this.L(item.key);
                item.checked = _.includes(this.rolePermissions, item.key);
                if (item.checked) {
                    this.selectedNodes.push(item.key);
                }
                parent.children.push(item);
                this.initTreeChildren(item, _.join(others, "."));
            }
        } else {
            if (!_.some(parent.children, c => c.name == permission)) {
                const key = parent.key + '.' + permission;
                const item = {
                    title: this.L(key),
                    name: permission,
                    key: key,
                    expand: false,
                    children: [],
                    checked: _.includes(this.rolePermissions, key)
                };
                if (item.checked) {
                    this.selectedNodes.push(item.key);
                }
                parent.children.push(item);
            }
        }
    }

    initTree(permissions) {
        var tree = [];
        _.forEach(permissions, permission => {
            if (_.includes(permission, ".")) {
                const [first, ...others] = permission.split(".");
                let item = _.find(tree, t => t.name == first);
                if (item) {
                    this.initTreeChildren(item, _.join(others, "."));
                } else {
                    var key = first;
                    item = {
                        name: first,
                        key: first,
                        expand: false,
                        children: [],
                        title: this.L(key),
                        checked: _.includes(this.rolePermissions, key)
                    };
                    if (item.checked) {
                        this.selectedNodes.push(first);
                    }
                    tree.push(item);
                    this.initTreeChildren(item, _.join(others, "."));
                }
            }
        });
        return tree;
    }
}